

  <div class="contents">

      <div class="area_of_impact">
        <div class="form_input">
          <h2 class="heading">Area Map of Spill</h2>
          </div>

          <div class="enteries" >
            <div class="the_table">
              <div class="the_head">
                <span class="head_item">S/N</span>
                <span class="head_item">Linkage Id</span>
                <span class="head_item">Area Map Of Spill Description</span>
              </div>

              <div class="the_row"  *ngFor="let areaOfSpill of selectedIncidentId.areaofspills; index as i"
               style="cursor: pointer;"
             >
                <span class="row_data">{{i + 1}}</span>
                <a class="row_data" style="text-decoration: none;" href="{{areaOfSpill.Url}}" target="_blank">{{areaOfSpill.LinkageId}}</a>

                <span class="row_data">{{areaOfSpill.AreaMapSpillDescription}}</span>


              </div>


            </div>

          </div>



        </div>


    </div>

